'use client';

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { safePostHogGetFeatureFlag, safePostHogOnFeatureFlags } from 'utils/posthogHelpers';

/**
 * Fires the PostHog $feature_flag_called exposure event for per-issuer
 * A/B test experiments (e.g., wind-harvest-form-v3).
 *
 * Calling getFeatureFlag client-side triggers PostHog's automatic exposure
 * tracking, which is required for experiment participation to be recorded.
 */
const PerIssuerExperimentExposure = ({ flagKey }) => {
  useEffect(() => {
    if (!flagKey) return;

    let hasFired = false;
    let mounted = true;

    const fireExposure = () => {
      if (!mounted || hasFired) return;
      safePostHogGetFeatureFlag(flagKey);
      hasFired = true;
    };

    safePostHogOnFeatureFlags(() => {
      fireExposure();
    });

    return () => {
      mounted = false;
    };
  }, [flagKey]);

  return null;
};

PerIssuerExperimentExposure.propTypes = {
  flagKey: PropTypes.string,
};

export default PerIssuerExperimentExposure;
